export const ADD_EXPENSE = 'ADD_EXPENSE';
export const ADDING_EXPENSE = 'ADDING_EXPENSE';
export const ADD_EXPENSE_SUCCESS = 'ADD_EXPENSE_SUCCESS';
export const RESET_ADD_EXPENSE_SUCCESS = 'RESET_ADD_EXPENSE_SUCCESS';
export const ADD_EXPENSE_FAILURE = 'ADD_EXPENSE_FAILURE';
export const REMOVE_EXPENSE = 'REMOVE_EXPENSE';
export const REMOVING_EXPENSE = 'REMOVING_EXPENSE';
export const REMOVE_EXPENSE_SUCCESS = 'REMOVE_EXPENSE_SUCCESS';
export const REMOVE_EXPENSE_FAILURE = 'REMOVE_EXPENSE_FAILURE';
export const TOGGLE_BOOKMARK_EXPENSE = 'TOGGLE_BOOKMARK_EXPENSE';
export const TOGGLING_BOOKMARK_EXPENSE = 'TOGGLING_BOOKMARK_EXPENSE';
export const TOGGLE_BOOKMARK_EXPENSE_SUCCESS =
	'TOGGLE_BOOKMARK_EXPENSE_SUCCESS';
export const TOGGLE_BOOKMARK_EXPENSE_FAILURE =
	'TOGGLE_BOOKMARK_EXPENSE_FAILURE';
export const LOAD_EXPENSES = 'LOAD_EXPENSES';
export const LOADING_EXPENSES = 'LOADING_EXPENSES';
export const LOAD_EXPENSES_SUCCESS = 'LOAD_EXPENSES_SUCCESS';
export const LOAD_EXPENSES_FAILURE = 'LOAD_EXPENSES_FAILURE';
